import { usePage } from "@inertiajs/react";

export default function Navbar() {
    const { url } = usePage();

    const isActive = (prefix) => url === prefix || url.startsWith(`${prefix}/`);
    const navClass = (prefix) =>
        `flex gap-x-3 lg:gap-x-1.5 py-2 px-3 w-full lg:w-auto items-center text-sm text-start text-navbar-nav-foreground rounded-lg hover:bg-navbar-nav-hover disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-navbar-nav-focus ${isActive(prefix) ? "bg-navbar-nav-active" : ""}`;

    return <>
        <nav className="relative bg-navbar border-b border-navbar-line">
            <div className="max-w-[85rem] flex flex-wrap justify-between gap-2 basis-full items-center w-full mx-auto lg:py-2.5 px-4 sm:px-6 lg:px-8">
                <div className="basis-full grow lg:basis-auto lg:grow-0">
                    <div id="hs-pro-emh" className="hs-collapse hidden overflow-hidden transition-all duration-300 lg:block" aria-labelledby="hs-pro-emh-collapse" role="region">
                        <div className="overflow-hidden overflow-y-auto max-h-[75vh] [&amp;::-webkit-scrollbar]:w-2 [&amp;::-webkit-scrollbar-thumb]:rounded-none [&amp;::-webkit-scrollbar-track]:bg-scrollbar-track [&amp;::-webkit-scrollbar-thumb]:bg-scrollbar-thumb0">
                            <div className="lg:flex lg:items-center lg:gap-x-1 py-2 lg:py-0 space-y-1 lg:space-y-0">
                                <a className={navClass("/panel/dashoard")} href="/panel/dashoard">
                                    Dashboard
                                </a>
                                <a className={navClass("/panel/products")} href="/panel/products">
                                    Product
                                </a>
                                <a className={navClass("/panel/members")} href="/panel/members">
                                    Member
                                </a>
                                <a className={navClass("/panel/invoices")} href="/panel/invoices">
                                    Invoice
                                </a>
                                <a className={navClass("/panel/payments")} href="/panel/payments">
                                    Payment
                                </a>
                                <a className={navClass("/panel/payment-method-lists")} href="/panel/payment-method-lists">
                                    Payment Method List
                                </a>
                                <a className={navClass("/panel/reseller-commissions")} href="/panel/reseller-commissions">
                                    Commission Ledger
                                </a>
                                <a className={navClass("/panel/commission-payouts")} href="/panel/commission-payouts">
                                    Payout Batches
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </nav>
    </>
}
